import {
  MainContainer,
  AuthContainer,
  LoginContainer
} from "./styles";
import AuthenticationActions, {
  AuthenticationSelectors
} from "Redux/AuthenticationRedux";
import React, { Component } from "react";

import { FacebookLoginButton } from "react-social-login-buttons";
import LoginForm from "Forms/LoginForm";
import SocialButton from "Components/SocialButton";
import { connect } from "react-redux";
import navRoutes from "Navigation/NavRoutes";
import { TitleHeader } from "Themes/StyledComponents";

import ProfileActions from "Redux/ProfileRedux";

class LoginScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      socialFacebookError: null,
      loginFetching: false
    };
    this.nodes = {};
  }

  setNodeRef(provider, node) {
    if (node) {
      this.nodes[provider] = node;
    }
  }

  componentDidUpdate(prevProps) {
    const { errors } = this.props;
    if (prevProps.errors !== errors) {
      this.setState({
        error: "Invalid username and password"
      });
    }
  }

  handleLoginSuccess = async () => {
    const resolve = {
      onSuccess: () => {},
      onFailure: e => this.setState({ error: e })
    };

    await this.props.getUserDetails();
    await this.props.getProfile(resolve);

    this.setState({
      loginFetching: false
    });

    this.props.history.push(navRoutes.updateFeed);
  };

  handleLoginFailure = e => {
    this.setState({
      error: e.detail,
      loginFetching: false
    });
  };

  handleSubmit = values => {
    const { login } = this.props;

    this.setState({
      loginFetching: true
    });

    const resolve = {
      onSuccess: () => this.handleLoginSuccess(),
      onFailure: e => this.handleLoginFailure(e)
    };
    login(values, resolve);
  };

  handleNavigation = () => {
    const { history } = this.props;
    history.push("");
  };

  handleSocialLoginFailure = err => {
    if (err.error) {
      console.log("[ERROR]", err.message);
      this.setState({
        socialFacebookError: err.message
      });
    }
  };

  handleSocialLoginSuccess = () => {
    console.log("Social Login Success!");
    this.handleLoginSuccess();
  };

  handleSocialLogin = async data => {
    const resolve = {
      onSuccess: () => this.handleSocialLoginSuccess(),
      onFailure: e => this.handleSocialLoginFailure(e)
    };
    const socialData = {
      provider: data["_provider"],
      uid: data["_profile"]["id"],
      inputToken: data["_token"]["accessToken"],
      profile: data["_profile"]
    };
    await this.props.socialLogin(socialData, resolve);
  };

  handleLogoutSuccess = () => {};

  renderFacebookButton = () => {
    return (
      <SocialButton
        provider="facebook"
        appId="261112561181160"
        onLoginSuccess={this.handleSocialLogin}
        onLoginFailure={this.handleSocialLoginFailure}
        onLogoutSuccess={this.onLogoutSuccess}
        getInstance={this.setNodeRef.bind(this, "facebook")}
        key={"facebook"}
        error={this.state.socialFacebookError}
      >
        <FacebookLoginButton />
      </SocialButton>
    );
  };

  render() {
    const { history } = this.props;
    const { loginFetching, error } = this.state;
    return (
      <MainContainer>
        <TitleHeader>Login</TitleHeader>
        <AuthContainer>
          <LoginContainer>
            <LoginForm
              handleSubmit={this.handleSubmit}
              handleNavigation={this.handleNavigation}
              loginError={error}
              history={history}
              forgottenPassword={() =>
                history.push(navRoutes.forgottenPassword)
              }
              fetching={loginFetching}
            />
          </LoginContainer>
        </AuthContainer>
      </MainContainer>
    );
  }
}

const mapStateToProps = state => {
  return {
    state: state,
    isAuthenticated: AuthenticationSelectors.getAuthenticated(state),
    errors: AuthenticationSelectors.getError(state),
    tokens: AuthenticationSelectors.getTokens(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getProfile: resolve => dispatch(ProfileActions.profileRequest(resolve)),
    login: (data, resolve) =>
      dispatch(AuthenticationActions.loginRequest(data, resolve)),
    socialLogin: (data, resolve) =>
      dispatch(AuthenticationActions.socialAuthLoginRequest(data, resolve)),
    getUserDetails: () =>
      dispatch(AuthenticationActions.getUserDetailsRequest())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginScreen);
